/* eslint-disable */
import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import EventQuotationsSellBody from "components/EventComponents/EventDetailsComponents/EventQuotationsSell/EventQuotationsSellBody/EventQuotationsSellBody";

const EventQuotationsSell = () => {
  useEffect(() => {
    document.title = "Event Quotations Sell";
  }, []);

  return (
    <>
      <main id="app">
        {/* ---- header start ---- */}
        <Header moduleName="events" />
        {/* --- header end --- */}
        <EventQuotationsSellBody />
      </main>
    </>
  );
};

export default EventQuotationsSell;
